module.exports = __webpack_public_path__ + "img/horizontal-orientatio-icon.7bc12c8.svg";